var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      opacity: 0.05
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 24,
    cy: 24,
    r: 19.5
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,5c10.477,0,19,8.523,19,19s-8.523,19-19,19S5,34.477,5,24S13.523,5,24,5 M24,4C12.954,4,4,12.954,4,24s8.954,20,20,20 s20-8.954,20-20S35.046,4,24,4L24,4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      opacity: 0.05
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 35,
    height: 35
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41,7v34H7V7H41 M42,6H6v36h36V6L42,6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filled"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "outlined"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "rounded"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "two_x5F_tone"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "sharp"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "win10"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "ios_x5F_out"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ios_x5F_filled"
  })), /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M45,16.2l-5,2.75l-5,4.75L35,40h7c1.657,0,3-1.343,3-3V16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E88E5"
    },
    d: "M3,16.2l3.614,1.71L13,23.7V40H6c-1.657,0-3-1.343-3-3V16.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E53935"
    },
    points: "35,11.2 24,19.45 13,11.2 12,17 13,23.7 24,31.95 35,23.7 36,17  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C62828"
    },
    d: "M3,12.298V16.2l10,7.5V11.2L9.876,8.859C9.132,8.301,8.228,8,7.298,8h0C4.924,8,3,9.924,3,12.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBC02D"
    },
    d: "M45,12.298V16.2l-10,7.5V11.2l3.124-2.341C38.868,8.301,39.772,8,40.702,8h0 C43.076,8,45,9.924,45,12.298z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "fluent"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.6e1d26b3abc35d2f592c74de930349be.svg";
export { ForwardRef as ReactComponent };